import { render, staticRenderFns } from "./HorizontalNavMenuHeaderLink.vue?vue&type=template&id=a9e3d928"
import script from "./HorizontalNavMenuHeaderLink.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuHeaderLink.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuHeaderLink.vue?vue&type=style&index=0&id=a9e3d928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports